import { render } from "./AuctionItemView.vue?vue&type=template&id=517cfd70&scoped=true"
import script from "./AuctionItemView.vue?vue&type=script&lang=js"
export * from "./AuctionItemView.vue?vue&type=script&lang=js"

import "./AuctionItemView.vue?vue&type=style&index=0&id=517cfd70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517cfd70"]])

export default __exports__